(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brass-badge-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brass-badge-personalization')) {
 const savedBadges = new Map();
 const includesLid = value => /\bsnuffer\s+lid\b/i.test(value) && !/^\s*(?:no\b|without\b)/i.test(value);
 const isYes = value => /^\s*yes\b/i.test(value);
 customElements.define('brass-badge-personalization', class extends HTMLElement {
  connectedCallback() {
   this.fields = [...this.querySelectorAll('select, textarea')];
   this.key = this.dataset.formId;
   this.variants = JSON.parse(this.querySelector('[data-badge-variants]')?.textContent || '[]');
   const saved = savedBadges.get(this.key);
   if (saved) this.fields.forEach(field => { if (saved[field.name] !== undefined) field.value = saved[field.name]; });
   this.save = () => {
    if (this.active) savedBadges.set(this.key, Object.fromEntries(this.fields.map(field => [field.name, field.value])));
   };
   this.readState = () => {
    const picker = document.getElementById(this.dataset.pickerId);
    const group = picker?.querySelector('[data-option-index="option' + this.dataset.optionPosition + '"]');
    const value = group?.querySelector('input:checked')?.value || group?.querySelector('select')?.value || '';
    const others = [...(picker?.querySelectorAll('[data-option-index^="option"]') || [])].filter(item => item !== group);
    const lid = others.some(item => includesLid(item.querySelector('input:checked')?.value || item.querySelector('select')?.value || ''));
    return { picker, group, value, lid };
   };
   this.update = () => {
    const state = this.readState();
    if (!state.group) {
     this.active = false;
     this.hidden = true;
     this.fields.forEach(field => { field.disabled = true; });
     return;
    }
    state.group.hidden = !state.lid;
    this.active = state.lid && isYes(state.value);
    this.hidden = !this.active;
    this.fields.forEach(field => {
     field.disabled = !this.active;
     if (!state.lid) {
      if (field.tagName === 'SELECT') field.selectedIndex = 0;
      else field.value = '';
     }
    });
    if (!state.lid) {
     savedBadges.delete(this.key);
     if (isYes(state.value)) {
      const noInput = [...state.group.querySelectorAll('input[type="radio"]')].find(input => /^\s*no\b/i.test(input.value));
      const select = state.group.querySelector('select');
      if (noInput) {
       noInput.checked = true;
       noInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (select) {
       const noOption = [...select.options].find(option => /^\s*no\b/i.test(option.value));
       if (noOption) {
        select.value = noOption.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
       }
      }
     }
    }
   };
   this.sanitizeVariant = (form, formData) => {
    const variantInput = form.elements.namedItem('id');
    const variantId = formData?.get('id') || variantInput?.value;
    const variant = this.variants.find(item => String(item.id) === String(variantId));
    const badgeIndex = Number(this.dataset.optionPosition) - 1;
    if (!variant || !isYes(variant.options[badgeIndex])) return;
    const hasLid = variant.options.some((value, index) => index !== badgeIndex && includesLid(value));
    if (hasLid) return;
    const fallback = this.variants.find(item => /^\s*no\b/i.test(item.options[badgeIndex]) && item.options.every((value, index) => index === badgeIndex || value === variant.options[index]));
    if (fallback) {
     if (variantInput) variantInput.value = fallback.id;
     if (formData) formData.set('id', fallback.id);
    }
   };
   this.changed = event => {
    if (this.contains(event.target)) this.save();
    const picker = document.getElementById(this.dataset.pickerId);
    if (picker?.contains(event.target)) this.update();
   };
   this.submitted = event => {
    if (event.target.getAttribute('id') !== this.key) return;
    this.update();
    this.sanitizeVariant(event.target);
   };
   this.formDataCreated = event => {
    if (event.target.getAttribute('id') !== this.key) return;
    this.update();
    this.sanitizeVariant(event.target, event.formData);
    if (!this.active) this.fields.forEach(field => event.formData.delete(field.name));
   };
   this.restored = () => this.update();
   this.addEventListener('input', this.save);
   document.addEventListener('change', this.changed);
   document.addEventListener('submit', this.submitted, true);
   document.addEventListener('formdata', this.formDataCreated, true);
   window.addEventListener('pageshow', this.restored);
   this.observer = new MutationObserver(this.update);
   this.observer.observe(this.closest('.shopify-section') || this.parentElement, { childList: true, subtree: true });
   this.update();
  }
  disconnectedCallback() {
   this.save?.();
   this.removeEventListener('input', this.save);
   document.removeEventListener('change', this.changed);
   document.removeEventListener('submit', this.submitted, true);
   document.removeEventListener('formdata', this.formDataCreated, true);
   window.removeEventListener('pageshow', this.restored);
   this.observer?.disconnect();
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
